/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Total_BagsInputs */

const en_inventory_metric_total_bags = /** @type {(inputs: Inventory_Metric_Total_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Bags`)
};

const es_inventory_metric_total_bags = /** @type {(inputs: Inventory_Metric_Total_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas totales`)
};

/**
* | output |
* | --- |
* | "Total Bags" |
*
* @param {Inventory_Metric_Total_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_total_bags = /** @type {((inputs?: Inventory_Metric_Total_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Total_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_total_bags(inputs)
	return es_inventory_metric_total_bags(inputs)
});